var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.088,
    height: 20.981,
    viewBox: "0 0 18.088 20.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_164-search",
    "data-name": "164-search",
    d: "M14.261,16.283a10.361,10.361,0,0,0,2.078-6.308C16.338,4.748,12.675.5,8.171.5S0,4.743,0,9.969s3.664,9.479,8.167,9.479A7.514,7.514,0,0,0,13.6,17.037l3.691,4.285a.426.426,0,0,0,.329.156.445.445,0,0,0,.329-.156.6.6,0,0,0,0-.759ZM.928,9.969c0-4.634,3.246-8.4,7.239-8.4s7.239,3.768,7.239,8.4-3.246,8.4-7.239,8.4S.928,14.6.928,9.969Zm0,0",
    transform: "translate(0 -0.496)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchVector);
export default __webpack_public_path__ + "static/media/SearchVector.ed346a7d35729fd140851617ac0a8fd8.svg";
export { ForwardRef as ReactComponent };